import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AumicoClipboardService } from '../../../../../aumico-lib-core-fe/src/lib';
import { AumicoClipboardData } from '../../../../../aumico-lib-core-fe/src/lib/interfaces/aumico-clipboard-data.interface';
import { NoteSelectionCard } from '../../interfaces/note-selection-card.interface';

@UntilDestroy()
@Component({
    selector: 'add-notes-component',
    templateUrl: './add-notes-component.component.html',
    styleUrls: ['./add-notes-component.component.scss'],
})
export class AddNotesComponent implements OnInit, OnDestroy {
    @Input() supportOperation = false;
    @Output() componentAdded = new EventEmitter<ComponentType>();
    @Output() pasteComponent = new EventEmitter<AumicoClipboardData>();
    @Output() close = new EventEmitter<void>();

    selectedNoteComponent: ComponentType | undefined;
    showClipboard = false;
    pasteComponentSelected = false;
    clipboardData: AumicoClipboardData | undefined;
    componentTitleInClipboard: string | undefined;
    componentTypeInClipboard: ComponentType | undefined;
    componentInClipboardImagePath: string | undefined;

    readonly notesComponents: NoteSelectionCard[] = [
        {
            title: 'aumico_notes_rich_text',
            imagePath: 'assets/images/aumico-rich-text-card-popup.svg',
            componentName: ComponentType.RICH_TEXT,
            shouldBeVisibleForUser: true,
        },
        {
            title: 'aumico_notes_simple_input',
            imagePath: 'assets/images/aumico-input-card-popup.svg',
            componentName: ComponentType.INPUT,
            shouldBeVisibleForUser: false,
        },
        {
            title: 'aumico_notes_super_table',
            imagePath: 'assets/images/aumico-super-table-card-popup1.svg',
            componentName: ComponentType.SUPER_TABLE,
            shouldBeVisibleForUser: true,
        },
        {
            title: 'aumico_notes_select',
            imagePath: 'assets/images/aumico-select-card-popup.svg',
            componentName: ComponentType.SELECT,
            shouldBeVisibleForUser: false,
        },
        {
            title: 'aumico_notes_movement_schedule',
            imagePath: 'assets/images/aumico-movement-schedule-card-popup.svg',
            componentName: ComponentType.MOVEMENT_SCHEDULE,
            shouldBeVisibleForUser: true,
        },
        {
            title: 'aumico_notes_free_table_with_amounts',
            imagePath: 'assets/images/aumico-freetable-card-popup.svg',
            componentName: ComponentType.FREE_TABLE_WITH_AMOUNTS,
            shouldBeVisibleForUser: true,
        },
        {
            title: 'aumico_notes_fli_table',
            imagePath: 'assets/images/aumico-fli-card-popup.svg',
            componentName: ComponentType.FINANCIAL_LINE_ITEM,
            shouldBeVisibleForUser: true,
        },
        {
            title: 'aumico_notes_equity_table',
            imagePath: 'assets/images/aumico-equity-card-popup.svg',
            componentName: ComponentType.EQUITY,
            shouldBeVisibleForUser: false,
        },
    ];

    constructor(private readonly aumicoClipboardService: AumicoClipboardService) {
        this.aumicoClipboardService
            .tryReadAumicoClipboard$()
            .pipe(untilDestroyed(this))
            .subscribe((clipboardData) => {
                if (clipboardData) {
                    this.showClipboard = true;
                    this.clipboardData = clipboardData;
                    this.componentTitleInClipboard = clipboardData.component.componentTitle?.['de-ch'];
                    this.componentTypeInClipboard = clipboardData.componentType;
                    this.componentInClipboardImagePath = this.notesComponents.find(
                        (c) => c.componentName === this.componentTypeInClipboard,
                    )?.imagePath;
                }
            });
    }

    ngOnInit(): void {}

    closeDialog(): void {
        this.close.emit();
    }

    onSelectComponent(componentName: ComponentType): void {
        this.selectedNoteComponent = componentName;
        this.pasteComponentSelected = false;
    }

    onAddComponent(): void {
        if (this.selectedNoteComponent != null) {
            this.componentAdded.emit(this.selectedNoteComponent);
            this.close.emit();
            return;
        }

        if (this.pasteComponentSelected && this.clipboardData) {
            this.pasteComponent.emit(this.clipboardData);
            this.close.emit();
            return;
        }
    }

    onPasteComponent(): void {
        this.selectedNoteComponent = undefined;
        this.pasteComponentSelected = true;
    }

    ngOnDestroy(): void {}
}
